import DOMReady from './utils/DOMReady'
import lazyLoad from './modules/lazy-load'
import navigation from './modules/navigation'

// Include css for webpack (for development only)
const css = require('../css/main.scss') // eslint-disable-line no-unused-vars

// Set CSP for 1st party scripts
if (window.trustedTypes && window.trustedTypes.createPolicy) {
  window.trustedTypes.createPolicy('default', {
    // eslint-disable-next-line no-unused-vars
    createHTML: (string, sink) => string,
  })
}

DOMReady(() => {
  lazyLoad.init()
  navigation.init()
})
